import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Row,
} from "reactstrap";
import { toast } from "react-toastify";

import {
  sendEmailOtp,
  sendPhoneOtp,
  verifyEmailOtp,
  verifyPhoneOtp
} from "../service/authApi";

const VerifyAccountPage = () => {

  const navigate = useNavigate();

  const userId = sessionStorage.getItem("registerUserId");
  const email = sessionStorage.getItem("registerEmail");
  const phoneNumber = sessionStorage.getItem("registerPhone");

  const [loading, setLoading] = useState(false);

  const [emailOtp, setEmailOtp] = useState("");
  const [phoneOtp, setPhoneOtp] = useState("");

  const [emailVerified, setEmailVerified] = useState(false);
  const [phoneVerified, setPhoneVerified] = useState(false);

  const [countdown, setCountdown] = useState(30);
  const [canResend, setCanResend] = useState(false);

  useEffect(() => {
    if (!userId) {
      navigate("/register", { replace: true });
      return;
    }

    // Automatically send Email OTP
    // handleSendEmailOtp();

  }, []);
useEffect(() => {
    if (emailVerified && phoneVerified) {
        setTimeout(() => {
            goToLogin();
        }, 1500);
    }
}, [emailVerified, phoneVerified]);
  useEffect(() => {
    if (canResend) return;

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          setCanResend(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [canResend]);

  const handleSendEmailOtp = async () => {

    if (!userId) return;

    try {

      setLoading(true);

      await sendEmailOtp({ userId });

      toast.success("Email OTP sent.");

      setCanResend(false);
      setCountdown(30);

    } catch (err: any) {

      toast.error(
        err?.response?.data?.message ??
        "Unable to send email OTP."
      );

    } finally {

      setLoading(false);

    }
  };

  const handleVerifyEmail = async () => {

    if (!userId) return;

    if (!emailOtp.trim()) {

      toast.error("Enter Email OTP");

      return;

    }

    try {

      setLoading(true);

      await verifyEmailOtp({

        userId,

        otp: emailOtp

      });

      setEmailVerified(true);
 

      toast.success("Email verified successfully.");
      // Automatically send phone OTP
      await handleSendPhoneOtp();
    }
    catch (err: any) {

      toast.error(
        err?.response?.data?.message ??
        "Invalid Email OTP."
      );

    }
    finally {

      setLoading(false);

    }

  };

  const handleSendPhoneOtp = async () => {

    if (!userId) return;

    try {

      setLoading(true);

      await sendPhoneOtp({
        userId
      });
 

      toast.success("Phone OTP sent.");

    }
    catch (err: any) {

      toast.error(
        err?.response?.data?.message ??
        "Unable to send Phone OTP."
      );

    }
    finally {

      setLoading(false);

    }

  };

  const handleVerifyPhone = async () => {

    if (!userId) return;

    if (!phoneOtp.trim()) {

      toast.error("Enter Phone OTP");

      return;

    }

    try {

      setLoading(true);

      await verifyPhoneOtp({

        userId,

        otp: phoneOtp

      });

      setPhoneVerified(true);
 

      toast.success("Phone verified successfully.");

      goToLogin();

    }
    catch (err: any) {

      toast.error(
        err?.response?.data?.message ??
        "Invalid Phone OTP."
      );

    }
    finally {

      setLoading(false);

    }

  };




  const handleResendEmail = async () => {
    if (!canResend) return;

    await handleSendEmailOtp();
  };

  const goToLogin = () => {

    sessionStorage.removeItem("registerUserId");
    sessionStorage.removeItem("registerEmail");
    sessionStorage.removeItem("registerPhone");

    navigate("/login");

  };

  if (!userId)
    return null;

  return (
    <div
      style={{
        minHeight: "90vh", 
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
      }}
    >
      <Container>
        <Row className="justify-content-center">
          <Col xl="6" lg="8" md="10">

            <Card
              style={{
                border: "none",
                borderRadius: 30,
                overflow: "hidden",
                boxShadow: "0 25px 60px rgba(0,0,0,.25)",
                background: "rgba(255,255,255,.95)",
                backdropFilter: "blur(15px)"
              }}
            >
            <CardBody style={{ padding: 35 }}>
  <div className="text-center mb-4">
    <div
      style={{
        width: 90,
        height: 90,
        margin: "0 auto 20px",
        borderRadius: "50%",
        background: "linear-gradient(135deg,#2563eb,#4f46e5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        fontSize: 40
      }}
    >
      🔐
    </div>

    <h2 style={{ fontWeight: 700 }}>
      Verify Your Account
    </h2>

    <p className="text-muted">
      Complete Email verification first, then verify your phone number.
    </p>
  </div>

  {/* EMAIL SECTION */}

  <Card className="shadow-sm border-0 mb-4">
    <CardBody>

      <h5>Email Verification</h5>

      <p className="text-muted mb-2">
        OTP sent to
        <br />
        <strong>{email}</strong>
      </p>

      <Input
        placeholder="Enter Email OTP"
        maxLength={6}
        value={emailOtp}
        disabled={emailVerified}
        onChange={(e) => setEmailOtp(e.target.value)}
      />

      {!emailVerified && (
        <>
          <Button
            color="primary"
            className="w-100 mt-3"
            onClick={handleVerifyEmail}
            disabled={loading}
          >
            Verify Email
          </Button>

          <div className="text-center mt-3">
            {!canResend ? (
              <small>
                Resend available in {countdown}s
              </small>
            ) : (
              <Button
                color="link"
                onClick={handleResendEmail}
              >
                Resend Email OTP
              </Button>
            )}
          </div>
        </>
      )}

      {emailVerified && (
        <div className="alert alert-success mt-3 mb-0">
            ✓ Email Verified Successfully
        </div>
      )}

    </CardBody>
  </Card>

  {/* PHONE SECTION */}

  {emailVerified && (

    <Card className="shadow-sm border-0">

      <CardBody>

        <h5>Phone Verification</h5>

        <p className="text-muted mb-2">
          OTP sent to
          <br />
          <strong>+91 {phoneNumber}</strong>
        </p>

        <Input
          placeholder="Enter Phone OTP"
          maxLength={6}
          value={phoneOtp}
          disabled={phoneVerified}
          onChange={(e) => setPhoneOtp(e.target.value)}
        />

        {!phoneVerified && (
          <Button
            color="success"
            className="w-100 mt-3"
            onClick={handleVerifyPhone}
            disabled={loading}
          >
            Verify Phone
          </Button>
        )}

        {phoneVerified && (
          <div className="alert alert-success mt-3 mb-0">
              ✓ Phone Verified Successfully
          </div>
        )}

      </CardBody>

    </Card>

  )}

</CardBody>
            </Card>

          </Col>
        </Row>
      </Container>
    </div>
  );

};

export default VerifyAccountPage;